import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { URLS } from "fire-wind-water/url";

Vue.use(VueRouter);
const tenantId = URLS.getURL("tenantId");
const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/home",
    name: "Index",
    meta: {
      title:
        tenantId == "949"
          ? "赛诺贝斯视频聚合站"
          : tenantId == "1355"
          ? "培训视频"
          : "视频聚合站"
    },
    component: Home
  },
  {
    path: "/category/:name/:value?",
    name: "Category",
    meta: {
      title:
        tenantId == "949"
          ? "视频分类_赛诺贝斯视频聚合站"
          : tenantId == "1355"
          ? "视频分类_培训视频"
          : "视频分类_视频聚合站"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/live",
    name: "Live",
    meta: {
      title:
        tenantId == "949"
          ? "直播预告_赛诺贝斯视频聚合站"
          : tenantId == "1355"
          ? "直播列表_培训视频"
          : "直播列表_视频聚合站"
    },
    component: () => import(/* webpackChunkName: "live" */ "../views/Live.vue")
  },
  {
    path: "/demand",
    name: "Demand",
    meta: {
      title:
        tenantId == "949"
          ? "往期回放_赛诺贝斯视频聚合站"
          : tenantId == "1355"
          ? "点播列表_培训视频"
          : "点播列表_视频聚合站"
    },
    component: () =>
      import(/* webpackChunkName: "demand" */ "../views/Demand.vue")
  },
  {
    path: "/search/:keyword?",
    name: "Search",
    meta: {
      title:
        tenantId == "949"
          ? "搜索结果页_赛诺贝斯视频聚合站"
          : tenantId == "1355"
          ? "搜索结果页_培训视频"
          : "搜索结果页_视频聚合站"
    },
    component: () =>
      import(/* webpackChunkName: "demand" */ "../views/Search.vue")
  },
  {
    path: "*", // 页面不存在的情况下会跳到404页面
    redirect: "/home",
    name: "notFound",
    hidden: true
  }
];

const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    //document.title = to.meta.title;
  }
  next();
});

export default router;
